namespace TabAurous.Stock {
    export interface StockItemRow {
        StockId?: number;
        RefTransId?: number;
        RefTransItemId?: number;
        TransId?: number;
        TransItemId?: number;
        VoucherDate?: string;
        VoucherTypeId?: number;
        VoucherNo?: string;
        CompanyId?: number;
        DepartmentId?: number;
        PartyId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        Lab?: string;
        LotNo?: string;
        CertificateNo?: string;
        Hallmark?: number;
        RefNo?: string;
        ProductId?: number;
        AttributeId?: number;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneRate?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        CalcOnId?: number;
        Rate?: number;
        ImageName?: string;
        FinancialYearId?: number;
        RefVoucherId?: number;
        Purity?: number;
        PureWeight?: number;
        POSCustomerId?: number;
        SetId?: number;
        MFAmount?: number;
        MF?: number;
        StockAllocation?: boolean;
        Parts?: number;
        HUID?: string;
        ExportPieces?: number;
        BOMDetails?: StockItemBOMRow[];
        DeptName?: string;
        LedgerName?: string;
        PartyCode?: string;
        CustomerName?: string;
        CompanyCode?: string;
        VoucherTypeName?: string;
        ProductCode?: string;
        ProductName?: string;
        IsCustomerItem?: boolean;
        HasBom?: boolean;
        TaxCode?: string;
        HSN?: string;
        CostMethodId?: number;
        MetalId?: number;
        DesignId?: number;
        DesignCode?: string;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        SuperTypeId?: number;
        CollectionId?: number;
        ItemTypeId?: number;
        ItemType?: string;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        Attribute?: string;
        SieveId?: number;
        KaratId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        MetalColorId?: number;
        StoneSizeId?: number;
        StoneSizeName?: string;
        SieveName?: string;
        StoneColoreName?: string;
        QualityName?: string;
        ShapeName?: string;
        MetalColorName?: string;
        KaratName?: string;
        BrandName?: string;
        CollectionName?: string;
        SuperTypeName?: string;
        MetalName?: string;
        StampId?: number;
        StampCode?: string;
        ProductSizeId?: number;
        ProductSizeCode?: string;
        PurchasePieces?: number;
        PurchaseAmount?: number;
        PurchaseReturnPieces?: number;
        PurchaseReturnAmount?: number;
        SalesPieces?: number;
        SalesAmount?: number;
        SalesReturnPieces?: number;
        SalesReturnAmount?: number;
        POSSalesPieces?: number;
        POSSalesAmount?: number;
        POSSalesReturnPieces?: number;
        POSSalesReturnAmount?: number;
        StoneCutId?: number;
        StoneCutCode?: string;
        StoneCutName?: string;
        StonePolishId?: number;
        StonePolishCode?: string;
        StonePolishName?: string;
        StoneSymmetryId?: number;
        StoneSymmetryCode?: string;
        StoneSymmetryName?: string;
        StoneFluorescenceId?: number;
        StoneFluorescenceCode?: string;
        StoneFluorescenceName?: string;
        StoneCuletId?: number;
        StoneCuletCode?: string;
        StoneCuletName?: string;
        StoneGirdleId?: number;
        StoneGirdleCode?: string;
        StoneGirdleName?: string;
        StoneTable?: string;
        StoneDepth?: string;
        MarquisePieces?: number;
        MarquiseWeight?: number;
        FancyPieces?: number;
        FancyWeight?: number;
        RoundPieces?: number;
        RoundWeight?: number;
        PreciousPieces?: number;
        PreciousWeight?: number;
        SemiPreciousPieces?: number;
        SemiPreciousWeight?: number;
        RoundSize?: string;
        OtherSize?: string;
        FancySize?: string;
        Fancy2Size?: string;
        Fancy2Pieces?: number;
        Fancy2Weight?: number;
    }

    export namespace StockItemRow {
        export const idProperty = 'StockId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Stock.StockItem';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            StockId = "StockId",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId",
            TransId = "TransId",
            TransItemId = "TransItemId",
            VoucherDate = "VoucherDate",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            CompanyId = "CompanyId",
            DepartmentId = "DepartmentId",
            PartyId = "PartyId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            Lab = "Lab",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            Hallmark = "Hallmark",
            RefNo = "RefNo",
            ProductId = "ProductId",
            AttributeId = "AttributeId",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneRate = "StoneRate",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            CalcOnId = "CalcOnId",
            Rate = "Rate",
            ImageName = "ImageName",
            FinancialYearId = "FinancialYearId",
            RefVoucherId = "RefVoucherId",
            Purity = "Purity",
            PureWeight = "PureWeight",
            POSCustomerId = "POSCustomerId",
            SetId = "SetId",
            MFAmount = "MFAmount",
            MF = "MF",
            StockAllocation = "StockAllocation",
            Parts = "Parts",
            HUID = "HUID",
            ExportPieces = "ExportPieces",
            BOMDetails = "BOMDetails",
            DeptName = "DeptName",
            LedgerName = "LedgerName",
            PartyCode = "PartyCode",
            CustomerName = "CustomerName",
            CompanyCode = "CompanyCode",
            VoucherTypeName = "VoucherTypeName",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            IsCustomerItem = "IsCustomerItem",
            HasBom = "HasBom",
            TaxCode = "TaxCode",
            HSN = "HSN",
            CostMethodId = "CostMethodId",
            MetalId = "MetalId",
            DesignId = "DesignId",
            DesignCode = "DesignCode",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            BrandId = "BrandId",
            SuperTypeId = "SuperTypeId",
            CollectionId = "CollectionId",
            ItemTypeId = "ItemTypeId",
            ItemType = "ItemType",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            Attribute = "Attribute",
            SieveId = "SieveId",
            KaratId = "KaratId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            MetalColorId = "MetalColorId",
            StoneSizeId = "StoneSizeId",
            StoneSizeName = "StoneSizeName",
            SieveName = "SieveName",
            StoneColoreName = "StoneColoreName",
            QualityName = "QualityName",
            ShapeName = "ShapeName",
            MetalColorName = "MetalColorName",
            KaratName = "KaratName",
            BrandName = "BrandName",
            CollectionName = "CollectionName",
            SuperTypeName = "SuperTypeName",
            MetalName = "MetalName",
            StampId = "StampId",
            StampCode = "StampCode",
            ProductSizeId = "ProductSizeId",
            ProductSizeCode = "ProductSizeCode",
            PurchasePieces = "PurchasePieces",
            PurchaseAmount = "PurchaseAmount",
            PurchaseReturnPieces = "PurchaseReturnPieces",
            PurchaseReturnAmount = "PurchaseReturnAmount",
            SalesPieces = "SalesPieces",
            SalesAmount = "SalesAmount",
            SalesReturnPieces = "SalesReturnPieces",
            SalesReturnAmount = "SalesReturnAmount",
            POSSalesPieces = "POSSalesPieces",
            POSSalesAmount = "POSSalesAmount",
            POSSalesReturnPieces = "POSSalesReturnPieces",
            POSSalesReturnAmount = "POSSalesReturnAmount",
            StoneCutId = "StoneCutId",
            StoneCutCode = "StoneCutCode",
            StoneCutName = "StoneCutName",
            StonePolishId = "StonePolishId",
            StonePolishCode = "StonePolishCode",
            StonePolishName = "StonePolishName",
            StoneSymmetryId = "StoneSymmetryId",
            StoneSymmetryCode = "StoneSymmetryCode",
            StoneSymmetryName = "StoneSymmetryName",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneFluorescenceCode = "StoneFluorescenceCode",
            StoneFluorescenceName = "StoneFluorescenceName",
            StoneCuletId = "StoneCuletId",
            StoneCuletCode = "StoneCuletCode",
            StoneCuletName = "StoneCuletName",
            StoneGirdleId = "StoneGirdleId",
            StoneGirdleCode = "StoneGirdleCode",
            StoneGirdleName = "StoneGirdleName",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            MarquisePieces = "MarquisePieces",
            MarquiseWeight = "MarquiseWeight",
            FancyPieces = "FancyPieces",
            FancyWeight = "FancyWeight",
            RoundPieces = "RoundPieces",
            RoundWeight = "RoundWeight",
            PreciousPieces = "PreciousPieces",
            PreciousWeight = "PreciousWeight",
            SemiPreciousPieces = "SemiPreciousPieces",
            SemiPreciousWeight = "SemiPreciousWeight",
            RoundSize = "RoundSize",
            OtherSize = "OtherSize",
            FancySize = "FancySize",
            Fancy2Size = "Fancy2Size",
            Fancy2Pieces = "Fancy2Pieces",
            Fancy2Weight = "Fancy2Weight"
        }
    }
}
